<ng-template ngFor let-assetObj [ngForOf]="assetInfoObject.metadata">
  <ng-template [ngIf]="asset[assetObj.formControlName] || asset['customFields']?.[assetObj.formControlName]">
    <div class="dataset-group">
      <div *ngIf="!editFlag || !assetObj.editable">
        <div class="dataset-entry flex row items-start" *ngIf="assetObj.formControlName === 'name'">
          <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
          <div
            class="dataset-entry-value inline-block w-3/5 break-words"
            [ngClass]="{
              'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable,
            }"
          >
            <span class="mr-2">{{ asset[assetObj.formControlName] }}</span>
          </div>
        </div>
        <div class="dataset-entry flex row items-start" *ngIf="assetObj.formControlName === 'description' && asset['description']">
          <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
          <div
            class="dataset-entry-value inline-block w-3/5 break-words"
            [ngClass]="{
              'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable,
            }"
          >
            <div class="ql-container ql-snow !min-h-[inherit] !bg-inherit !border-0">
              <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="asset[assetObj.formControlName || '']"></div>
            </div>
          </div>
        </div>
        <div class="dataset-entry flex row items-start" *ngIf="['createdBy', 'updatedBy'].includes(assetObj.formControlName)">
          <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
          <div class="dataset-entry-value inline-block w-3/5">
            <span class="cursor-pointer hover:bg-[#e3e0e0] -m-1 px-1 py-1 rounded-lg" (click)="assetCommonService.onClick(assetObj.formControlName, asset)">
              {{ (valueListsService.lookupUserInfo(asset[assetObj.formControlName]) | async)?.name }}
            </span>
          </div>
        </div>
        <ng-container *ngIf="['domains'].includes(assetObj.formControlName)">
          <ng-template ngFor let-domain [ngForOf]="assetDomains" let-i="index">
            <hr />
            <div class="xdomain-item">
              <ng-template ngFor let-innerAssetObj [ngForOf]="assetObj.formFieldsGroup">
                <div class="dataset-entry flex row items-start" *ngIf="['agency', 'client', 'brand'].includes(innerAssetObj.formControlName)">
                  <span class="dataset-entry-label w-2/5 field-label">{{ innerAssetObj.fieldLabel }}</span>
                  <div class="dataset-entry-value inline-block w-3/5">
                    <span>{{ domain[innerAssetObj.formControlName]?.name }}</span>
                  </div>
                </div>
                <div class="dataset-entry flex row items-start" *ngIf="domain[innerAssetObj.formControlName] && ['category', 'product', 'subcategory'].includes(innerAssetObj.formControlName)">
                  <span class="dataset-entry-label w-2/5 field-label">{{ innerAssetObj.fieldLabel }}</span>
                  <div class="dataset-entry-value inline-block w-3/5">
                    <span>{{ domain[innerAssetObj.formControlName] | optionsLabel: assetObj['options'] }}</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </ng-template>
          <hr />
        </ng-container>
        <div class="dataset-entry flex row items-start" *ngIf="['createdAt', 'updatedAt', 'expiryDate', 'publishStartDate', 'publishEndDate'].includes(assetObj.formControlName)">
          <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
          <div class="dataset-entry-value inline-block w-3/5">
            <span *ngIf="asset[assetObj.formControlName]; else noValue">{{ asset[assetObj.formControlName] | spDateFormat: { isSafe: true } }}</span>
            <ng-template #noValue> </ng-template>
          </div>
        </div>
        <div class="dataset-entry flex row items-start" *ngIf="assetObj.formControlName === 'status'">
          <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
          <div class="dataset-entry-value inline-block w-3/5">
            <span>{{ asset[assetObj.formControlName] | customTitleCase }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
